import { graphql } from "react-relay";

export const QUERY = graphql`
	query accountLicensesTable_Query($id: ID!) {
		...accountLicensesTable_QueryFragment @arguments(id: $id)
	}
`;

export const QUERY_FRAGMENT = graphql`
	fragment accountLicensesTable_QueryFragment on Query
	@refetchable(queryName: "accountLicensesTable_Refetch")
	@argumentDefinitions(id: { type: "ID!" }, first: { type: "Int" }, after: { type: "String" }) {
		node(id: $id) {
			... on Account {
				id
				name
				extension(accountExtensionKind: Tka) {
					... on TkaAccountExtension {
						licenses(first: $first, after: $after)
							@connection(key: "accountLicensesTable_licenses") {
							__id
							pageInfo {
								startCursor
								endCursor
								hasNextPage
								hasPreviousPage
							}
							edges {
								node {
									...accountLicensesTable_LicenseFragment
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const LICENSE_FRAGMENT = graphql`
	fragment accountLicensesTable_LicenseFragment on License @inline {
		id
		creationInfo {
			kind
			createdAt
			licenseDefinition {
				data {
					name
				}
			}
			... on LicenseCreatedByOrder {
				orderId
			}
			... on LicenseCreatedByAdmin {
				creatorId
			}
			... on LicenseCreatedByRegistration {
				userId
			}
		}
		usage {
			kind
			... on LicenseUsageUsedForTree {
				at
				forUser {
					email
				}
			}
		}
	}
`;
